import React from 'react'
import InstructorNavbar from "../components/instructor/InstructorNavbar"
import UpdateMarks from '../components/instructor/UpdateMarks'

const UpdateMarksPage = () => {
  return (
    <div>
       <InstructorNavbar/>
       <UpdateMarks/>
    </div>
  )
}

export default UpdateMarksPage